import { getAttributeFromClause } from '@gonfalon/clauses/getAttributeFromClause';
import { translateToText } from '@gonfalon/clauses/translateToText';
import { AttributeReference } from '@gonfalon/contexts/attributes/AttributeReference';
import type { List } from '@gonfalon/immutable-shim/immutableShim';

import type { Clause } from '#utils/clause/records/Clause';
import type { Segment } from '#utils/segment/records/Segment';
import { mobileAttributesMapping } from '#utils/userAttributeUtils';

export function translateImmutableClauseToText(clause: Clause, segments?: List<Segment>) {
  const plainClause = clause.toJS();
  const attribute = new AttributeReference(getAttributeFromClause(plainClause)).toString();
  return translateToText(plainClause, attribute, mobileAttributesMapping, segments ? segments.toJS() : undefined);
}
